import { call, takeEvery, takeLatest } from 'redux-saga/effects';
import axios from 'axios';

import { isFunc } from '@utils/functions';

const Api = {
  getPortals: () => axios.get('/portals'),
  getPortalCredentials: ({ scope, portal, owner }) => axios.get('/portal-credentials', { params: { scope, portal, owner } }),
  getPortalCredential: (id) => axios.get(`/portal-credentials/${id}`),
  createPortalCredential: ({ portal, credentials }) => axios.post('/portal-credentials', { portal, credentials }),
  updatePortalCredential: ({ id, credentials }) => axios.put(`/portal-credentials/${id}`, { credentials }),
  deletePortalCredential: (id) => axios.delete(`/portal-credentials/${id}`),
  initiatePortalSession: (credential) => axios.post('/portal-sessions', { credential }),
  getPortalSessions: ({ page, limit, credential }) => axios.get('/portal-sessions', { params: { page, limit, credential } }),
};

export const actionTypes = {
  GET_PORTALS: 'GET_PORTALS',
  GET_PORTAL_CREDENTIALS: 'GET_PORTAL_CREDENTIALS',
  GET_PORTAL_CREDENTIAL: 'GET_PORTAL_CREDENTIAL',
  CREATE_PORTAL_CREDENTIAL: 'CREATE_PORTAL_CREDENTIAL',
  UPDATE_PORTAL_CREDENTIAL: 'UPDATE_PORTAL_CREDENTIAL',
  DELETE_PORTAL_CREDENTIAL: 'DELETE_PORTAL_CREDENTIAL',
  INITIATE_PORTAL_SESSION: 'INITIATE_PORTAL_SESSION',
  GET_PORTAL_SESSIONS: 'GET_PORTAL_SESSIONS',
};

const createSaga = (apiCall, getArgs) => function* ({ payload }) {
  const { onSuccess, onError } = payload ?? {};
  try {
    const result = yield call(apiCall, getArgs(payload ?? {}));
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
};

export const getPortals = payload => ({ type: actionTypes.GET_PORTALS, payload });
export const getPortalCredentials = payload => ({ type: actionTypes.GET_PORTAL_CREDENTIALS, payload });
export const getPortalCredential = payload => ({ type: actionTypes.GET_PORTAL_CREDENTIAL, payload });
export const createPortalCredential = payload => ({ type: actionTypes.CREATE_PORTAL_CREDENTIAL, payload });
export const updatePortalCredential = payload => ({ type: actionTypes.UPDATE_PORTAL_CREDENTIAL, payload });
export const deletePortalCredential = payload => ({ type: actionTypes.DELETE_PORTAL_CREDENTIAL, payload });
export const initiatePortalSession = payload => ({ type: actionTypes.INITIATE_PORTAL_SESSION, payload });
export const getPortalSessions = payload => ({ type: actionTypes.GET_PORTAL_SESSIONS, payload });

const sagas = [
  takeLatest(actionTypes.GET_PORTALS, createSaga(Api.getPortals, () => undefined)),
  takeLatest(actionTypes.GET_PORTAL_CREDENTIALS, createSaga(Api.getPortalCredentials, ({ scope, portal, owner }) => ({ scope, portal, owner }))),
  takeLatest(actionTypes.GET_PORTAL_CREDENTIAL, createSaga(Api.getPortalCredential, ({ id }) => id)),
  takeEvery(actionTypes.CREATE_PORTAL_CREDENTIAL, createSaga(Api.createPortalCredential, ({ portal, credentials }) => ({ portal, credentials }))),
  takeEvery(actionTypes.UPDATE_PORTAL_CREDENTIAL, createSaga(Api.updatePortalCredential, ({ id, credentials }) => ({ id, credentials }))),
  takeEvery(actionTypes.DELETE_PORTAL_CREDENTIAL, createSaga(Api.deletePortalCredential, ({ id }) => id)),
  takeEvery(actionTypes.INITIATE_PORTAL_SESSION, createSaga(Api.initiatePortalSession, ({ credential }) => credential)),
  takeLatest(actionTypes.GET_PORTAL_SESSIONS, createSaga(Api.getPortalSessions, ({ page, limit, credential }) => ({ page, limit, credential }))),
];

export default sagas;
